import styled from 'styled-components';

const Wrapper = styled.div`
    overflow: hidden;
`;

export default Wrapper;
